module.exports = "/_next/static/resources/woman-1-e4e778cbef21f0276700889c4880e48b.jpg";